import * as _ from 'lodash'
import { network, docC } from '../globals'
import { Path } from '../lib/Path'
import { Cursor, CursorV } from '../lib/Cursor'
import * as Model from '../types/document'
import { Stack } from 'src/types/stack';
import { evaluateNode, evaluateSteps } from 'src/model/evaluate';

type NodeIsActiveTable = {[nodeId: string]: boolean}

export const nodeIsActive = network.valueFunc('nodeIsActive', (blockC: Cursor<Model.Block>, nodeId: Model.NodeId, stack: Stack): boolean => {
  return nodeIsActiveTable(blockC,stack)[nodeId]
})

export const nodeIsActiveTable = network.valueFunc('nodeIsActiveTable', (blockC: Cursor<Model.Block>, stack: Stack): NodeIsActiveTable => {
  const nodeIsActiveTable = {}
  populateForInputs(nodeIsActiveTable, blockC.select('inputs'), stack)
  populateForSteps(nodeIsActiveTable, blockC.select('steps'), stack)
  return nodeIsActiveTable
})

function populateForInputs(nodeIsActiveTable: NodeIsActiveTable, inputsC: Cursor<Array<Model.Node>>, stack: Stack) {
  inputsC.get().forEach((input) => {
    nodeIsActiveTable[input.id] = true
  })
}

function populateForSteps(nodeIsActiveTable: NodeIsActiveTable, maybeStepsC: Cursor<Model.Steps | undefined>, stack: Stack) {
  const stepsC = maybeStepsC.fetch().call(CursorV.unwrapMaybe)
  if (stepsC) {
    stepsC.call(CursorV.elemsKeyed, 'id').forEach((stepC) =>
      populateForStep(nodeIsActiveTable, stepC.unfetch(), stack)
    )
  }
}

function populateForStep(nodeIsActiveTable: NodeIsActiveTable, stepC: Cursor<Model.Step>, stack: Stack): void {
  const step = stepC.get()

  switch (step.stepType) {
  case 'graph': {
    const graph = step as Model.Graph
    _.forEach(graph.nodes, (node) => {
      nodeIsActiveTable[node.id] = true
    })
    break }
  case 'switch': {
    // TODO: this is terrible! we are just reiterating evaluation logic and returning something different!
    // I hate that.
    const switchC = stepC as Cursor<Model.Switch>
    for (let caseC of CursorV.elems(switchC.select('cases').fetch())) {
      const conditionC = CursorV.unwrapMaybe(caseC.select('condition'))
      if (conditionC) {
        populateForSteps(nodeIsActiveTable, conditionC.unfetch(), stack)
        const conditionResult = evaluateSteps(conditionC.unfetch(), stack)
        if (conditionResult.type !== 'value') {
          // propagate error in condition. (semantics question: we could just go to the next case?)
          break
        }
        if (!conditionResult.value) {
          continue // abort case, on to next case
        }
      }

      // this is our case! let's run it
      populateForSteps(nodeIsActiveTable, caseC.select('steps').unfetch(), stack)
      break
    }
    nodeIsActiveTable[switchC.get().output.id] = true
    break }
  case 'text':
    break
  }
}



// WEBPACK FOOTER //
// ./src/model/nodeIsActive.ts